import styled from '@emotion/styled'

const BudgetFormContainer = styled.div`
`

export {
  BudgetFormContainer
}